import React from 'react';
import Content from "../components/Content/Content";
import classes from "../App.module.scss";
const MainBooks = () => {
    return (
        <div className={classes.App}>
            <Content/>
        </div>
    );
};

export default MainBooks;